import { getHookCheckoutItems } from '../../utils';
import { getItemDiscount } from '../../../../utils/item';
import { createAddOnRecord } from '../../../../addOnsUtil';
import { redirectCartPage } from '../../../../utils/redirect';
import {
  createCustomSubtotal,
  setSubtotalDiscountVisible,
  updateSubtotalNumbers
} from '../../ui/subtotal';
import { getAppProps, isDawnTheme, isDebutTheme } from '../../../../utils';
import { injectDawnLineSubotal } from './dawn';
import { injectDebutLineSubotal } from './debut';

export function getTotalPrice() {
  const items = getHookCheckoutItems();

  let originalTotalPrice = 0;
  let totalPrice = 0;

  items.forEach(v => {
    const { price, quantity } = v;

    const correctedPrice = price / 100;

    const discount = getItemDiscount(v);

    const cost = correctedPrice - (correctedPrice / 100) * discount;
    totalPrice = totalPrice + cost * quantity;

    originalTotalPrice = originalTotalPrice + correctedPrice * quantity;
  });

  return {
    originalTotalPrice,
    totalPrice
  };
}

async function checkCartChangeInAddon(addOnsDb, oldState, newState) {
  let refreshPage = false;

  for (const itemOld of oldState) {
    // Check state diff
    const id = itemOld.id;
    const founded = newState.find(v => v.id === id);

    if (!founded) {
      const productId = itemOld.product_id;
      const defaultVariant = itemOld.product_has_only_default_variant;

      let iterId = null;

      if (defaultVariant) {
        iterId = `${productId}`;
      } else {
        iterId = `${productId}|${id}`;
      }

      let itemsPerCollection = null;

      for (const key in addOnsDb) {
        if (key.includes(iterId)) {
          itemsPerCollection = addOnsDb[key];
          break;
        }
      }

      // If we have products attached to upsell main product
      if (itemsPerCollection) {
        for (const key in itemsPerCollection) {
          const parsed = createAddOnRecord(itemsPerCollection, key);
          const { ids, specified } = parsed;

          // Should remove from cart?
          if (specified) {
            await jUpsell.ajax({
              url: '/cart/change.js',
              dataType: 'json',
              data: {
                quantity: 0,
                id: ids[0]
              },
              type: 'POST',
              xhrFields: {
                withCredentials: true
              }
            });

            refreshPage = true;
          }
        }
      }
    }
  }

  return refreshPage;
}

export async function detectCartChanges(oldState, newState) {
  const { addOnsDb, popups } = getAppProps();

  // Check popups changes
  const popupsChanged = await checkCartChangeInAddon(
    popups,
    oldState,
    newState
  );

  // Check addon changes
  const addonsChanged = await checkCartChangeInAddon(
    addOnsDb,
    oldState,
    newState
  );

  if (popupsChanged || addonsChanged) {
    redirectCartPage();
  }
}

export function injectSubtotal({ subtotalOriginal, subtotal }) {
  const hasDiscount = subtotalOriginal !== subtotal;

  createCustomSubtotal();
  updateSubtotalNumbers(subtotalOriginal, subtotal);
  setSubtotalDiscountVisible(hasDiscount);
}

export function injectLineSubtotal(args) {
  if (isDebutTheme()) {
    injectDebutLineSubotal(args);
  }

  if (isDawnTheme()) {
    injectDawnLineSubotal(args);
  }
}
